import { Ban } from 'lucide-react';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

interface ScanInfoCardProps {
  measuring: boolean;
  errorMessage?: string;
}

function ScanInfoCardImpl({ measuring, errorMessage }: ScanInfoCardProps) {
  const { t } = useTranslation();

  if (errorMessage) {
    return (
      <div className='w-full px-3 py-2.5 bg-white rounded-[10px] shadow-sm sm:px-4 sm:py-3 md:px-6 md:py-4 md:rounded-xl'>
        <div className='flex items-center justify-center gap-1.5 px-1 sm:gap-2'>
          <Ban className='w-5 h-5 shrink-0 text-[#DC143C] sm:w-6 sm:h-6' />
          <p className='text-base font-semibold text-center text-[#DC143C] sm:text-lg md:whitespace-nowrap'>
            {errorMessage}
          </p>
        </div>
      </div>
    );
  }

  if (measuring) {
    return (
      <div className='w-full px-3 py-2.5 bg-white rounded-[10px] shadow-sm sm:px-4 sm:py-3 md:px-6 md:py-4 md:rounded-xl'>
        <div className='px-1 text-center sm:px-2'>
          <p className='text-base font-semibold text-black leading-tight sm:text-lg md:whitespace-nowrap'>
            {t('scanning_your_face')}
          </p>
          <p className='mt-0.5 text-xs text-black leading-snug sm:mt-1 sm:text-sm md:whitespace-nowrap'>
            {t('medsi_scan_face_centered_hint')}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className='w-full px-3 py-2.5 bg-white rounded-xl shadow-sm sm:px-4 sm:py-3 md:px-6 md:py-4'>
      <p className='text-sm font-semibold text-center text-black sm:text-base md:text-lg md:whitespace-nowrap'>
        {t('medsi_scan_ready_title')}
      </p>
      <p className='mt-1 text-xs text-center text-black sm:text-sm md:whitespace-nowrap'>
        {t('medsi_scan_ready_subtitle')}
      </p>
    </div>
  );
}

export const ScanInfoCard = memo(ScanInfoCardImpl);
